import { connect } from "react-redux";
import Layout from "../components/layout/Layout";
import * as C from "../components/cart/cart-styles";
import Link from "next/link";
import {
  clearCart,
  closeCart,
  decreaseCnt,
  deleteFromCart,
  increaseCnt,
  openCart,
} from "../redux/action/cart";
import { priceComma } from "../common/splicePrice";
import { useRouter } from "next/router";
import { useEffect, useMemo } from "react";
import {
  basketsAPI,
  basketsPDF,
  deleteBasket,
  fetchBaskets,
  insertBaskets,
} from "../api/baskets";
import { getCookie } from "../common/auth";
import { useState } from "react";
import { failAlert, successAlert } from "../common/alert";
import {
  deleteBasketsAction,
  fetchBasketsAction,
  clearBasketsAction,
} from "../redux/action/baskets";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../redux/action/confirm";
import { isLoaded, isLoading } from "../redux/action/loading";
import { SettlementAPI, StoreOrderApi } from "../api/order";
import getUserAgent from "../common/util/getUserAgent";
import { fileDownloadHelper, pdfDownloadHelper } from "../common/files";
import Cart from "../components/cart/cart";
import RequestLoginModal from "../components/elements/requestLoginModal";
import { Spinner } from "react-bootstrap";
import { NPayModalWrapper } from "../components/products/detail/ProductDetails-styles";
import NasaVariable from "../common/scripts/NasaVariable";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const CartPage = ({
  cartItems,
  increaseCnt,
  decreaseCnt,
  deleteFromCart,
  clearCart,
  deleteBasketsAction,
  fetchBasketsAction,
  basketItems,
  basketCount,
  clearBasketsAction,
  modifyConfirmModal,
  openConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
  userDevice,
  userInfo,
}) => {
  const [cartProducts, setCartProducts] = useState(null);
  const router = useRouter();
  // 선택 상품
  const [selectedItem, setSelectedItem] = useState([]);
  const [confirmItems, setConfirmItems] = useState([]);
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [directProduct, setDirectProduct] = useState({});
  const [selectModal, setSelectModal] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [relatedLoading, setRelatedLoading] = useState(false);

  const isUser = useMemo(() => {
    if (userInfo?.Member?.ukey) {
      return true;
    } else {
      return false;
    }
  }, [userInfo]);

  // 토큰 유무 판별
  const checkToken = async () => {
    if (isUser) {
      if (!basketItems) return;
      setCartProducts(basketItems);
      setSelectedItem(
        new Array(basketItems ? basketItems.length : 1).fill(true)
      );
      setConfirmItems(basketItems);

      setCartLoading(false);
    } else {
      setCartProducts(cartItems);
      setSelectedItem(new Array(cartItems ? cartItems.length : 1).fill(true));
      setConfirmItems(cartItems);

      setCartLoading(false);
    }
  };

  // 장바구니 연관상품 불러오기
  const fetchRelated = async () => {
    if (relatedProducts && relatedProducts.length > 0) return;
    setRelatedLoading(true);
    try {
      const body = {
        modes: "RelationProducts",
        items: JSON.stringify(cartProducts.map((el) => el.pcode)),
      };
      const res = await basketsAPI(body);

      if (res.Code === "0000") {
        setRelatedProducts(res.Data?.Rows);
        setRelatedLoading(false);
      } else {
        failAlert(res.Data?.Msg);
        console.error(res.Data?.Msg);
        setRelatedLoading(false);
      }
    } catch (error) {
      console.error(error);
      setRelatedLoading(false);
    }
  };

  // 결제하기
  const onClickCheckout = async () => {
    if (cartProducts?.length < 1) {
      return failAlert("장바구니에 상품이 없습니다");
    }

    if (confirmItems.filter((el) => el != undefined)?.length < 1) {
      return failAlert("선택된 상품이 없습니다");
    }

    sessionStorage.setItem(
      "cartOrder",
      JSON.stringify(confirmItems.filter((el) => el != undefined))
    );

    router.push({
      pathname: "/checkout",
      query: {
        type: "cart",
      },
    });
  };

  // 장바구니 삭제
  const deleteBasketProduct = async (item) => {
    deleteBasketsAction(item);
  };

  // 삭제 모달
  const handleDelete = (item, i) => {
    const content = {
      title: "삭제하시겠습니까?",
      actionBtnLabel: "확인",
      actionBtnValid: true,
      cancelBtnLabel: "취소",
      onAction: () => {
        userInfo?.Member?.ukey
          ? deleteBasketProduct(item, i)
          : deleteFromCart(item.pcode, i);
        confirmItems.splice(i, 1);
        setConfirmItems([...confirmItems]);
        selectedItem.splice(i, 1);
        setSelectedItem([...selectedItem]);
        closeConfirmModal();
      },
    };
    modifyConfirmModal(content);
    openConfirmModal();
  };

  // 회원 장바구니 갯수 증가
  const increaseBasketProduct = async (item) => {
    const i = cartProducts.findIndex((el) => el.pcode === item.pcode);
    cartProducts[i].cnt = Number(cartProducts[i].cnt) + 1;
    const body = {
      modes: "InsertSet",
      items: JSON.stringify([{ pcode: item.pcode, cnt: cartProducts[i].cnt }]),
    };
    const data = await insertBaskets(body);
    if (data?.code === "0000") {
      setConfirmItems(data?.data);
      setCartProducts(data?.data);
    }
  };

  // 회원 장바구니 갯수 감소
  const decreaseBasketProduct = async (item) => {
    const i = cartProducts.findIndex((el) => el.pcode === item.pcode);
    if (cartProducts[i].cnt > 1)
      cartProducts[i].cnt = Number(cartProducts[i].cnt) - 1;

    const body = {
      modes: "InsertSet",
      items: JSON.stringify([{ pcode: item.pcode, cnt: cartProducts[i].cnt }]),
    };
    const data = await insertBaskets(body);

    if (data?.code === "0000") {
      setConfirmItems(data?.data);
      setCartProducts(data?.data);
    }
  };

  // 네이버 주문
  const naverpayCheckout = async () => {
    isLoading();
    try {
      const body = {
        modes: "OrderTemp",
        division: "store",
        price: price() + deliveryPrice(),
        naverYn: "Y",
        items: JSON.stringify(confirmItems.filter((el) => el != undefined)),
        flowCode: getCookie("NA_CO"),
        clickId: getCookie("NVADID"),
        slog: sessionStorage.getItem("slog") || "",
        mobileYn: userDevice === "mobile" ? "Y" : "N",
      };
      const res = await StoreOrderApi(body);
      if (res?.Code === "0000") {
        const UserAgent = getUserAgent();
        const widerplanet_device =
          UserAgent.match(
            /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
          ) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null
            ? "mobile"
            : "web";
        if (widerplanet_device === "web") {
          window.open(
            `https://order.pay.naver.com/customer/buy/${res?.Data?.sertParam}`
          );
        }
        if (widerplanet_device === "mobile") {
          router.push(
            `https://m.pay.naver.com/o/customer/buy/${res?.Data?.sertParam}`
          );
        }
        isLoaded();
      } else {
        isLoaded();
        failAlert(res?.Data?.Msg);
      }
    } catch (error) {
      isLoaded();
      console.error(error.message);
      alert(error.message);
    }
    isLoaded();
  };

  // 장바구니 견적서 생성
  const cartEstimate = async () => {
    if (confirmItems.filter((el) => el != undefined)?.length < 1) {
      failAlert("견적서를 생성할 상품을 선택해주세요.");
      return;
    }
    isLoading();
    const body = {
      modes: "Estimate",
      items: JSON.stringify(confirmItems.filter((el) => el != undefined)),
    };
    const res = await basketsPDF(body);
    pdfDownloadHelper(res);
    isLoaded();
  };

  // 전체 선택
  const selectAllItems = (e) => {
    if (e.target.checked) {
      const tempArr = new Array(cartProducts.length).fill(true);
      setSelectedItem(tempArr);
      setConfirmItems(cartProducts);
    } else {
      const tempArr2 = new Array(cartProducts.length).fill(false);
      setSelectedItem(tempArr2);
      setConfirmItems([]);
    }
  };

  // 견적 선택
  const selectItem = (i, el) => (e) => {
    const tempArr = [...selectedItem];
    tempArr[i] = e.target.checked;
    setSelectedItem(tempArr);
    if (e.target.checked) {
      const tempArr2 = [...confirmItems];
      tempArr2.push(el);
      setConfirmItems(tempArr2);
    } else {
      const tempArr2 = [...confirmItems];
      const index = tempArr2.findIndex((product) => product.pcode === el.pcode);
      tempArr2.splice(index, 1);
      setConfirmItems(tempArr2);
    }
  };

  // 장바구니 비우기
  const deleteAll = () => {
    isUser ? clearBasketsAction() : clearCart();
  };

  // check deliveryPrice
  const checkDeliveryPrice = (item) => {
    if (
      item.delivery_type_korea === "무료" ||
      item.delivery_type_korea === "착불"
    ) {
      return `${item.delivery_type_korea}배송`;
    }

    if (item.bundle === "Y") {
      return (
        item.delivery_type_korea +
        " " +
        priceComma(Number(item.delivery_price) * Number(item.cnt)) +
        "원" +
        "(개별 묶음 배송 상품)"
      );
    } else {
      return (
        item.delivery_type_korea + " " + priceComma(item?.delivery_price) + "원"
      );
    }
  };

  // 전체 금액
  const price = () => {
    let price = 0;
    confirmItems?.forEach((item) => (price += item.discount_price * item.cnt));

    return price;
  };
  // 할인,할증 없는 배송료
  const nonCheckDelPrice = () => {
    let delPrice = 0;

    confirmItems?.forEach(
      (item) =>
        (delPrice +=
          (item.delivery_type === "무료" || item.delivery === "무료"
            ? 0
            : item.delivery_price) * (item.bundle === "Y" ? item.cnt : 1))
    );
    return delPrice;
  };
  // 할인,할증 포함 배송료
  const deliveryPrice = () => {
    let delPrice = 0;
    let baesong_temp = [];

    confirmItems.forEach((temp_item) => {
      let delivery_price_temp = 0;
      if (temp_item.delivery_type === "C" || temp_item.delivery === "C")
        return 0;

      delivery_price_temp = Number(temp_item.delivery_price);

      let delivery_price = 0;
      if (
        temp_item.delivery_type === "A" ||
        temp_item.delivery_type === "F" ||
        temp_item.delivery === "A" ||
        temp_item.delivery === "F"
      ) {
        if (temp_item.bundle === "Y") {
          delivery_price = delivery_price_temp * Number(temp_item.cnt);
        } else if (temp_item.bundle === "N") {
          if (baesong_temp.includes(temp_item.supplier)) {
            delivery_price = 0;
          } else {
            delivery_price = delivery_price_temp;
            baesong_temp.push(temp_item.supplier);
          }
        }
      } else {
        delivery_price = delivery_price_temp;
      }

      delPrice += delivery_price;
    });
    return delPrice;
  };

  // 비회원 바로 구매 모달 오픈
  const handleLoginModal = () => {
    setOpenLoginModal((prev) => !prev);
  };

  // 개별 바로 구매
  const purchaseDirect = (product) => () => {
    setDirectProduct(product);
    if (!isUser && !openLoginModal) {
      handleLoginModal();
      return;
    } else {
      sessionStorage.setItem(
        "directOrder",
        JSON.stringify([{ ...product, cnt: product.cnt }])
      );
      router.push({
        pathname: "/checkout",
        query: {
          type: "direct",
        },
      });
    }
  };

  useEffect(() => {
    setCartLoading(true);
    checkToken();
  }, [userInfo, cartItems, basketItems]);

  useEffect(() => {
    if (!router.isReady) return;

    if (cartProducts && cartProducts.length > 0) {
      fetchRelated();
      var UserAgent = navigator.userAgent;
      var widerplanet_device =
        UserAgent.match(
          /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
        ) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null
          ? "mobile"
          : "web";
      var wptg_tagscript_vars = globalThis.wptg_tagscript_vars || [];
      wptg_tagscript_vars.push(function () {
        return {
          wp_hcuid: userInfo?.Member?.id || "",
          ti: "54644",
          ty: "Cart",
          device: widerplanet_device,
          items: cartProducts.map((el) => {
            return { i: el.pcode, t: el.pname };
          }),
        };
      });
      globalThis.wptg_tagscript?.exec();
      // <!-- ADN Tracker[장바구니] start -->
      try {
        if (window.fn_across_adn_contain) {
          var across_adn_cart_contain = new fn_across_adn_contain();
          var across_adn_cart_param = [];
          across_adn_cart_param = {
            ut: "Cart",
            ui: "108274",
            items: cartProducts.map((el) => {
              return {
                i: el.pcode,
                c: el.pname,
                q: el.cnt,
                p: Number(el.cnt) * Number(el.discount_price),
              };
            }),
          };
          across_adn_cart_contain.init(across_adn_cart_param);
        }
      } catch (error) {
        console.error(error);
      }
      // <!-- ADN Tracker[장바구니] end -->
    }
  }, [router.isReady, cartProducts]);

  return (
    <>
      {cartProducts && cartProducts.length > 0 && (
        <NasaVariable type={"3"} value={"0"} />
      )}
      <Layout
        parent="홈"
        sub="장바구니"
        pageTitle={SeoMeta.cart.title}
        pageDesc={SeoMeta.cart.description}
        pageKeyword={SeoMeta.cart.keywords}
      >
        {cartLoading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "300px" }}
          >
            <Spinner />
          </div>
        )}
        {!cartLoading && cartProducts && (
          <Cart
            cartProducts={cartProducts}
            deleteAll={deleteAll}
            selectAllItems={selectAllItems}
            selectedItem={selectedItem}
            selectItem={selectItem}
            increaseBasketProduct={increaseBasketProduct}
            decreaseBasketProduct={decreaseBasketProduct}
            isUser={isUser}
            decreaseCnt={decreaseCnt}
            increaseCnt={increaseCnt}
            handleDelete={handleDelete}
            cartEstimate={cartEstimate}
            onClickCheckout={onClickCheckout}
            naverpayCheckout={naverpayCheckout}
            checkDeliveryPrice={checkDeliveryPrice}
            price={price}
            deliveryPrice={deliveryPrice}
            nonCheckDelPrice={nonCheckDelPrice}
            purchaseDirect={purchaseDirect}
            confirmItems={confirmItems}
            setSelectModal={setSelectModal}
            relatedProducts={relatedProducts}
            relatedLoading={relatedLoading}
          />
        )}
      </Layout>
      {openLoginModal && (
        <RequestLoginModal
          handleLoginModal={handleLoginModal}
          openLoginModal={openLoginModal}
          purchaseDirect={purchaseDirect}
          product={directProduct}
          cnt={directProduct.cnt}
        />
      )}
      {selectModal && (
        <NPayModalWrapper>
          <div className="modal-section">
            <div className="modal-content">
              <div className="desc">
                <p>
                  Npay로 결제 시 주문내역은
                  <br /> 네이버에서 확인할 수 있습니다. <br />
                </p>
                <p>
                  칼렛스토어 구매를 선택하시면 포인트 1% 적립,
                  <br />
                  적립금 사용 및 쿠폰 적용이 가능합니다.
                </p>
              </div>
              <div className="btnWrapper">
                <span className="cancel" onClick={() => setSelectModal(false)}>
                  칼렛스토어 구매
                </span>
                <span className="confirm" onClick={() => naverpayCheckout()}>
                  <img
                    src="/assets/imgs/product/payment_icon_naver.png"
                    alt="네이버페이 구매"
                  />
                  구매
                </span>
              </div>
            </div>
          </div>
        </NPayModalWrapper>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  cartItems: state.cart,
  activeCart: state.counter,
  basketItems: state.baskets.items,
  basketCount: state.baskets.count,
  loading: state.loading.loading,
  userInfo: state.userInfo,
});

const mapDispatchToProps = {
  increaseCnt,
  decreaseCnt,
  deleteFromCart,
  clearCart,
  deleteBasketsAction,
  fetchBasketsAction,
  clearBasketsAction,
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartPage);
